<script setup>
import { onMounted, onUnmounted, ref, watch } from "vue";
import { Head, router } from "@inertiajs/vue3";

import VAlert from "@/Shared/VAlert.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import { Html5QrcodeScanner } from "html5-qrcode";

const props = defineProps({
    title: String,
    additional: Object,
});

const { urlShow } = props.additional;

let html5QrcodeScanner = null;

const isShowAlert = ref(true);
const isShowForm = ref(false);
const qrcontent = ref("");

const breadcrumbs = [
    {
        url: "#",
        label: "Documents",
    },
];
const onScanSuccess = (decodedText, decodedResult) => {
    // Handle the successful scan result
    qrcontent.value = decodedText;
};

watch(qrcontent, (newValue) => {
    if (!newValue) {
        return false;
    }

    const urlObject = new URL(newValue);
    const searchParams = urlObject.searchParams;

    const uuid = searchParams.get("uuid");
    if (!uuid) {
        console.log("data empty");
        return false;
    }

    const url = urlShow.replace("uuid", uuid);

    router.get(url);
});

const onScanError = (errorMessage) => {
    // Handle scan errors
    // console.warn(`QR Code scan error: ${errorMessage}`);
};

onMounted(() => {
    const config = {
        fps: 10, // Frames per second
        qrbox: { width: 300, height: 300 }, // Size of the QR box
        // Other configurations like disableFlip, etc.
    };

    html5QrcodeScanner = new Html5QrcodeScanner(
        "qr-code",
        config,
        /* verbose= */ false // Set to true for more detailed logs
    );

    html5QrcodeScanner.render(onScanSuccess, onScanError);
});

onUnmounted(() => {
    // Stop the scanner when the component is unmounted
    if (html5QrcodeScanner) {
        html5QrcodeScanner.clear().catch((error) => {
            console.error("Failed to clear html5QrcodeScanner:", error);
        });
    }
});
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <VAlert v-if="!isShowForm && isShowAlert" />

        <div class="card">
            <div class="card-body d-flex justify-content-center">
                <div class="wrapper-scanner my-4 mx-2">
                    <div id="qr-code"></div>

                    <div class="row justify-content-center mt-2">
                        <div class="col-12">
                            <input
                                id="qrcodecontent"
                                class="form-control"
                                v-model="qrcontent"
                                @focus="qrcontent = ''"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.wrapper-scanner {
    aspect-ratio: 1;
    width: 300px;
}
</style>
